export enum VMState {
  Starting,
  Running,
  Stopping,
  Stopped,
  Deallocating,
  Deallocated,
  Unknown,
}
